"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrintPurchaseReceiptInstruction = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const printPurchaseReceiptStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['purchaseReceiptBump', beet.u8],
], 'PrintPurchaseReceiptInstructionArgs');
const printPurchaseReceiptInstructionDiscriminator = [227, 154, 251, 7, 180, 56, 100, 143];
function createPrintPurchaseReceiptInstruction(accounts, args) {
    const { purchaseReceipt, listingReceipt, bidReceipt, bookkeeper, instruction } = accounts;
    const [data] = printPurchaseReceiptStruct.serialize({
        instructionDiscriminator: printPurchaseReceiptInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: purchaseReceipt,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: listingReceipt,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: bidReceipt,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: bookkeeper,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: instruction,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('hausS13jsjafwWwGqZTUQRmWyvyxn9EQpqMwV1PBBmk'),
        keys,
        data,
    });
    return ix;
}
exports.createPrintPurchaseReceiptInstruction = createPrintPurchaseReceiptInstruction;
//# sourceMappingURL=printPurchaseReceipt.js.map